import React from 'react';
import Modal from '../Modal/Modal';
import './notificationmodal.scss';

function NotificationModal({ isOpen, message, style }) {
	return (
		<Modal open={isOpen} style={{ ...style, minWidth: 'unset' }}>
			<div className='noti'>{message}</div>
		</Modal>
	);
}

export default NotificationModal;
